module.exports = __webpack_public_path__ + "static/media/test7_2.ced5cc57.png";